import { toIsoCode, isoCountryName } from "@/app/(app)/_lib/iso-countries";
import { Flag } from "@/components/flag";

type CountryTagProps = {
  iso?: string;
  country?: string;
  size?: number;
};

export function CountryTag({ iso, country, size = 16 }: CountryTagProps) {
  const code = resolveIso(iso, country);
  if (!code) {
    return <span>{country ?? iso ?? ""}</span>;
  }
  return (
    <span className="inline-flex items-center gap-1.5" title={isoCountryName(code)}>
      <Flag iso={code} size={size} />
      <span>{code}</span>
    </span>
  );
}

function resolveIso(iso?: string, country?: string): string | null {
  return toIsoCode(iso ?? country) || null;
}
